interface LoadingDotsProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

interface ThreeDotsFadeIconProps {
  size?: number;
  className?: string;
}

/**
 * Three dots with fade animation - matches @workspace/ui LoadingDots
 */
function ThreeDotsFadeIcon({ size = 24, className }: ThreeDotsFadeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 12"
      width={size}
      height={size}
      fill="none"
      className={`text-muted-foreground ${className || ""}`}
    >
      <circle cx="4" cy="6" r="2" fill="currentColor">
        <animate
          attributeName="opacity"
          dur="1.2s"
          values="1;0.2;1"
          repeatCount="indefinite"
          begin="0s"
        />
      </circle>
      <circle cx="12" cy="6" r="2" fill="currentColor">
        <animate
          attributeName="opacity"
          dur="1.2s"
          values="1;0.2;1"
          repeatCount="indefinite"
          begin="0.4s"
        />
      </circle>
      <circle cx="20" cy="6" r="2" fill="currentColor">
        <animate
          attributeName="opacity"
          dur="1.2s"
          values="1;0.2;1"
          repeatCount="indefinite"
          begin="0.8s"
        />
      </circle>
    </svg>
  );
}

export function LoadingDots({ className, size = "md" }: LoadingDotsProps) {
  const sizeMap = {
    sm: 16,
    md: 24,
    lg: 32,
  };

  return (
    <div className={`flex items-center justify-center ${className || ""}`}>
      <ThreeDotsFadeIcon size={sizeMap[size]} />
    </div>
  );
}

export { ThreeDotsFadeIcon };
